import { CardContainer } from '../../components/ui/components'

import { FullLogoSvg } from '../../assets/icons/svgComponents'

import { Content, Subtitle, Wrapper } from './styles'

const PageNotFound = () => {
  return (
    <Wrapper>
      <CardContainer style="container">
        <Content>
          <FullLogoSvg colorLetters="#6F6F6E" colorX="#00995D" />
          <Subtitle>psi</Subtitle>
          <h3>Erro: 404</h3>
          <h4>Página não encontrada.</h4>
        </Content>
      </CardContainer>
    </Wrapper>
  )
}
export default PageNotFound
